import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/stations/")({
  beforeLoad: ({ search }) => {
    throw redirect({
      to: "/dashboard",
      search,
      replace: true,
    })
  },
})
